import { render, staticRenderFns } from "./ListArbobuilds.vue?vue&type=template&id=406aada6&"
import script from "./ListArbobuilds.vue?vue&type=script&lang=js&"
export * from "./ListArbobuilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports